/* Carrito lateral Clara Duarte.
   Si algo falla aquí, los enlaces a la cesta y el formulario de compra
   siguen funcionando sin JavaScript y llevan al carrito normal. */
(function () {
  'use strict';
  var root = document.getElementById('sj-cart');
  if (!root || !window.fetch || !window.Promise || !window.FormData) return;

  var D = root.dataset;
  var urls = { cart: D.cartUrl || '/cart', add: D.addUrl || '/cart/add', change: D.changeUrl || '/cart/change', clear: D.clearUrl || '/cart/clear', shop: D.shopUrl || '/collections/all' };
  var FREE = parseInt(D.free, 10) || 0;
  var fmt;
  try { fmt = new Intl.NumberFormat('es-ES', { style: 'currency', currency: D.currency || 'EUR' }); }
  catch (e) { fmt = { format: function (n) { return n.toFixed(2).replace('.', ',') + ' €'; } }; }
  function money(c) { return fmt.format((c || 0) / 100); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]; }); }

  var panel = root.querySelector('.sj-cart-panel');
  var body = root.querySelector('[data-cart-body]');
  var foot = root.querySelector('[data-cart-foot]');
  var errBox = root.querySelector('[data-cart-err]');
  var nLabel = root.querySelector('[data-cart-n]');
  var subEl = root.querySelector('[data-cart-subtotal]');
  var shipBox = root.querySelector('[data-cart-ship]');
  var shipText = root.querySelector('[data-cart-ship-text]');
  var shipBar = root.querySelector('[data-cart-ship-bar]');
  var shipDot = root.querySelector('[data-cart-ship-dot]');
  var saveEl = root.querySelector('[data-cart-save]');
  var discEl = root.querySelector('[data-cart-disc]');
  var upBox = root.querySelector('[data-cart-up]');
  var upRow = root.querySelector('[data-cart-up-row]');
  var lastFocus = null, closeTimer = null, busy = false;
  var rootUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* ---------- Contador en los iconos de la cesta ---------- */
  function cartPath() { return urls.cart.replace(/\/$/, ''); }
  function isCartLink(a) {
    if (!a || !a.getAttribute('href') || a.closest('#sj-cart')) return false;
    var u;
    try { u = new URL(a.href, location.href); } catch (e) { return false; }
    return u.origin === location.origin && u.pathname.replace(/\/$/, '') === cartPath() && !u.search;
  }
  function badges(count) {
    var links = document.querySelectorAll('a[href]');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      if (!isCartLink(a)) continue;
      var b = a.querySelector('.sj-cart-count');
      if (!b) {
        b = document.createElement('span');
        b.className = 'sj-cart-count';
        b.setAttribute('aria-hidden', 'true');
        a.classList.add('sj-has-count');
        a.appendChild(b);
        if (!a.dataset.sjLabel) a.dataset.sjLabel = a.getAttribute('aria-label') || 'Ver cesta';
      }
      b.textContent = count > 99 ? '99+' : String(count);
      b.hidden = !count;
      a.setAttribute('aria-label', a.dataset.sjLabel + (count ? ' (' + count + (count === 1 ? ' artículo)' : ' artículos)') : ''));
    }
  }

  /* ---------- Datos de producto (precio anterior y tallas) ---------- */
  var CMP = {};
  try { var cmpEl = document.getElementById('sj-cart-cmp'); if (cmpEl) CMP = JSON.parse(cmpEl.textContent) || {}; } catch (e) { CMP = {}; }
  var PROD = {}, asked = {};
  function getProd(h) {
    if (PROD[h]) return Promise.resolve(PROD[h]);
    return fetch(rootUrl + 'products/' + encodeURIComponent(h) + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { if (p) { PROD[h] = p; (p.variants || []).forEach(function (v) { CMP[v.id] = v.compare_at_price || 0; }); } return p; });
  }
  function loadCmp(cart) {
    var need = {};
    (cart.items || []).forEach(function (it) { if (!(it.variant_id in CMP) && it.handle && !asked[it.handle]) need[it.handle] = it; });
    var hs = Object.keys(need);
    if (!hs.length) return;
    Promise.all(hs.map(function (h) {
      asked[h] = true;
      return getProd(h).catch(function () {}).then(function () { if (!(need[h].variant_id in CMP)) CMP[need[h].variant_id] = 0; });
    })).then(function () { if (root.dataset.count !== '0') paintSave(lastCart); });
  }

  /* ---------- Ahorro total (precio anterior de cada prenda menos lo que pagas) ---------- */
  function cartDiscounts(cart) {
    return (cart.cart_level_discount_applications || []).map(function (a) {
      var app = a.discount_application || a;
      var amt = a.total_allocated_amount != null ? a.total_allocated_amount : (a.amount != null ? a.amount : app.total_allocated_amount);
      return { title: app.title || '', amount: amt || 0 };
    }).filter(function (d) { return d.amount > 0; });
  }
  function savings(cart) {
    var total = 0;
    (cart.items || []).forEach(function (it) {
      var unit = it.final_price != null ? it.final_price : Math.round(it.final_line_price / (it.quantity || 1));
      var before = Math.max(CMP[it.variant_id] || 0, it.original_price || 0);
      if (before > unit) total += (before - unit) * it.quantity;
    });
    cartDiscounts(cart).forEach(function (d) { total += d.amount; });
    return total;
  }
  function paintSave(cart) {
    if (!saveEl) return;
    var s = savings(cart);
    saveEl.textContent = s > 0 ? 'Ahorras ' + money(s) : '';
    saveEl.hidden = !(s > 0);
    if (discEl) {
      var apps = cartDiscounts(cart);
      discEl.innerHTML = apps.map(function (a) { return '<span class="sj-disc-r"><span>' + esc(a.title) + '</span><b>−' + money(a.amount) + '</b></span>'; }).join('');
      discEl.hidden = !apps.length;
    }
  }
  var lastCart = { items: [] };

  /* ---------- Envío gratis: línea de meta con un punto que avanza (sin mostrar cantidades) ---------- */
  var ICON_TRUCK = '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="7" cy="17" r="2"/><circle cx="17" cy="17" r="2"/><path d="M5 17H3v-4M2 5h11v12m-4 0h6m4 0h2v-6h-8m0-5h5l3 5M3 9h4"/></svg>';
  var ICON_OK = '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M9 12l2 2 4-4"/></svg>';
  function shipMsg(p) {
    if (p >= 100) return '¡Tienes el envío gratis!';
    if (p < 40) return 'Vas de camino al envío gratis';
    if (p < 80) return 'Te queda poco para el envío gratis';
    return '¡Ya casi tienes el envío gratis!';
  }
  function paintShip(total, n) {
    if (!FREE || !shipBox) { if (shipBox) shipBox.hidden = true; return; }
    var p = Math.max(0, Math.min(100, Math.round(total / FREE * 100)));
    var done = p >= 100;
    shipBox.classList.toggle('is-done', done);
    shipText.innerHTML = '<span class="sj-ship-ic">' + (done ? ICON_OK : ICON_TRUCK) + '</span>' + shipMsg(p);
    if (shipBar) shipBar.style.width = p + '%';
    if (shipDot) { shipDot.style.left = p + '%'; shipDot.classList.toggle('is-done', done); }
    shipBox.hidden = !n;
  }

  /* ---------- Completa tu look (joyería y calzado) ---------- */
  var UP = [];
  try { var upEl = document.getElementById('sj-cart-up'); if (upEl) UP = JSON.parse(upEl.textContent) || []; } catch (e) { UP = []; }
  function sized(src, w) { if (!src) return ''; if (src.indexOf('//') === 0) src = 'https:' + src; return src + (src.indexOf('?') < 0 ? '?' : '&') + 'width=' + w; }
  function titleHTML(t) { var p = String(t).split('|'); return '<b>' + esc(p[0].trim()) + '</b>' + (p[1] ? ' · ' + esc(p[1].trim()) : ''); }
  function paintUp(cart) {
    if (!upBox || !upRow) return;
    var n = cart.item_count || 0;
    var have = {};
    (cart.items || []).forEach(function (it) { have[it.handle] = 1; });
    var list = UP.filter(function (x) { return !have[x.h]; }).slice(0, 8);
    upBox.hidden = !n || !list.length;
    if (upBox.hidden) { upRow.innerHTML = ''; return; }
    upRow.innerHTML = list.map(function (x) {
      var off = x.c > x.p;
      return '<div class="sj-up-c" data-up-h="' + esc(x.h) + '"><a class="sj-up-i" href="' + esc(x.u) + '">' + (x.i ? '<img src="' + esc(sized(x.i, 120)) + '" alt="" loading="lazy" width="44" height="56">' : '') + '</a>' +
        '<div class="sj-up-d"><p class="sj-up-t">' + titleHTML(x.t) + '</p><p class="sj-up-p">' + (off ? '<s>' + money(x.c) + '</s>' : '') + '<strong>' + money(x.p) + '</strong></p></div>' +
        '<button type="button" class="sj-up-add" data-up-add="' + x.v + '" data-up-m="' + (x.m ? 1 : 0) + '" aria-label="Añadir ' + esc(String(x.t).split('|')[0].trim()) + '">Añadir</button></div>';
    }).join('');
  }
  function optLabel(p) {
    var names = (p.options || []).map(function (o) { return typeof o === 'string' ? o : (o && o.name) || ''; }).filter(Boolean);
    return names.join(' / ') || 'Talla';
  }
  /* Si el complemento tiene tallas, al pulsar «Añadir» se elige la talla en la misma tarjeta */
  function askSize(card, btn) {
    btn.disabled = true; btn.textContent = '…';
    getProd(card.getAttribute('data-up-h')).then(function (p) {
      if (!p) throw new Error();
      var vs = (p.variants || []).filter(function (v) { return v.available; });
      if (!vs.length) throw new Error();
      if (vs.length === 1) { addUp(btn, vs[0].id); return; }
      var lab = optLabel(p);
      var d = card.querySelector('.sj-up-d');
      d.querySelector('.sj-up-p').outerHTML = '<select class="sj-up-sel" data-up-sel aria-label="Elige ' + esc(lab.toLowerCase()) + '"><option value="">Elige ' + esc(lab.toLowerCase()) + '</option>' +
        vs.map(function (v) { return '<option value="' + v.id + '">' + esc(v.title) + '</option>'; }).join('') + '</select>';
      card.classList.add('is-size');
      btn.outerHTML = '<button type="button" class="sj-up-x" data-up-x aria-label="Cancelar">×</button>';
      var s = card.querySelector('[data-up-sel]');
      if (s) s.focus();
    }).catch(function () { location.href = card.querySelector('.sj-up-i').href; });
  }
  function addUp(btn, vid) {
    if (busy) return;
    if (btn) { btn.disabled = true; btn.textContent = 'Añadiendo…'; }
    act(post(urls.add, { id: vid, quantity: 1 }).then(getCart));
  }

  /* ---------- Pintar el carrito ---------- */
  function lineHTML(it) {
    var img = it.image ? it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=240' : '';
    var vt = it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '';
    var was = it.original_line_price > it.final_line_price ? '<s>' + money(it.original_line_price) + '</s>' : '';
    var q = it.quantity;
    return '<div class="sj-line" data-key="' + esc(it.key) + '">' +
      '<a class="sj-line-img" href="' + esc(it.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="' + esc(it.product_title) + '" loading="lazy">' : '') + '</a>' +
      '<div><a class="sj-line-t" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
      (vt ? '<p class="sj-line-v">' + esc(vt) + '</p>' : '') +
      '<p class="sj-line-p">' + was + '<strong>' + money(it.final_line_price) + '</strong></p>' +
      '<div class="sj-line-row"><div class="sj-qty" role="group" aria-label="Cantidad de ' + esc(it.product_title) + '">' +
      '<button type="button" data-q="' + (q - 1) + '" aria-label="Quitar una unidad"' + (q <= 1 ? ' disabled' : '') + '>−</button>' +
      '<output aria-live="polite">' + q + '</output>' +
      '<button type="button" data-q="' + (q + 1) + '" aria-label="Añadir una unidad">+</button></div>' +
      '<button type="button" class="sj-line-rm" data-q="0">Quitar</button></div></div></div>';
  }
  function render(cart) {
    var n = cart.item_count || 0;
    lastCart = cart;
    badges(n);
    nLabel.textContent = n ? '(' + n + ')' : '';
    paintShip(cart.total_price || 0, n);
    if (!n) {
      body.innerHTML = '<div class="sj-cart-empty"><p>Tu cesta está vacía.</p><a class="sj-cart-shop" href="' + esc(urls.shop) + '">Seguir comprando</a></div>';
      foot.hidden = true;
    } else {
      body.innerHTML = cart.items.map(lineHTML).join('');
      foot.hidden = false;
      subEl.textContent = money(cart.total_price);
      paintSave(cart);
      loadCmp(cart);
    }
    paintUp(cart);
    root.dataset.count = n;
  }
  function showErr(msg) { errBox.textContent = msg || ''; errBox.hidden = !msg; }

  function json(r) {
    return r.json().catch(function () { return {}; }).then(function (j) {
      if (!r.ok) { var e = new Error(j.description || j.message || 'Error'); e.data = j; throw e; }
      return j;
    });
  }
  function post(url, data) {
    return fetch(url + '.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(data || {}) }).then(json);
  }
  function getCart() { return fetch(urls.cart + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(json); }
  function refresh() { return getCart().then(function (c) { render(c); return c; }); }

  /* ---------- Abrir y cerrar ---------- */
  function focusables() { return panel.querySelectorAll('a[href],button:not([disabled]),input,select,textarea,[tabindex]:not([tabindex="-1"])'); }
  function open() {
    clearTimeout(closeTimer);
    if (!root.classList.contains('is-open')) lastFocus = document.activeElement;
    root.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    void root.offsetWidth;
    root.classList.add('is-open');
    setTimeout(function () { panel.focus(); }, 30);
  }
  function close() {
    if (root.hidden) return;
    root.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    closeTimer = setTimeout(function () { root.hidden = true; }, 320);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-close]')) { close(); return; }
    var clr = e.target.closest('[data-cart-clear]');
    if (clr) { act(post(urls.clear)); return; }
    if (e.target.closest('[data-up-x]')) { paintUp(lastCart); return; }
    var up = e.target.closest('[data-up-add]');
    if (up) {
      if (busy) return;
      if (up.getAttribute('data-up-m') === '1') askSize(up.closest('.sj-up-c'), up);
      else addUp(up, parseInt(up.getAttribute('data-up-add'), 10));
      return;
    }
    var q = e.target.closest('[data-q]');
    if (q) {
      var line = q.closest('.sj-line');
      line.classList.add('is-busy');
      act(post(urls.change, { id: line.dataset.key, quantity: parseInt(q.dataset.q, 10) }));
    }
  });
  root.addEventListener('change', function (e) {
    var s = e.target.closest('[data-up-sel]');
    if (!s || !s.value) return;
    s.disabled = true;
    addUp(null, parseInt(s.value, 10));
  });
  function act(p) {
    if (busy) return;
    busy = true; showErr('');
    p.then(render).catch(function (err) {
      showErr(err && err.message && err.message !== 'Error' ? err.message : 'No se ha podido actualizar la cesta. Inténtalo de nuevo.');
      return refresh();
    }).catch(function () {}).then(function () { busy = false; });
  }
  document.addEventListener('keydown', function (e) {
    if (root.hidden) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key === 'Tab') {
      var f = focusables(); if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------- Enlaces a la cesta: abren el panel ---------- */
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest('a[href]');
    if (!isCartLink(a)) return;
    e.preventDefault();
    showErr('');
    open();
    refresh().catch(function () { location.href = urls.cart; });
  });

  /* ---------- Añadir a la cesta sin recargar ---------- */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (e.defaultPrevented || !f.matches || !f.matches('form[data-sj-ajax]')) return;
    e.preventDefault();
    var btn = f.querySelector('[type="submit"]');
    var msg = f.querySelector('[data-sj-error]');
    var label = btn ? btn.textContent : '';
    if (msg) { msg.textContent = ''; msg.hidden = true; }
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); btn.textContent = 'Añadiendo…'; }
    fetch(urls.add + '.js', { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json' }, body: new FormData(f) })
      .then(json)
      .then(function () { return refresh(); })
      .then(function () { showErr(''); open(); })
      .catch(function (err) {
        var t = err && err.message && err.message !== 'Error' ? err.message : 'No se ha podido añadir a la cesta. Inténtalo de nuevo.';
        if (msg) { msg.textContent = t; msg.hidden = false; } else { showErr(t); open(); }
      })
      .then(function () {
        if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); btn.textContent = label; }
        f.dispatchEvent(new CustomEvent('sj:added', { bubbles: true }));
      });
  });

  window.SJCart = { open: function () { open(); return refresh(); }, close: close, refresh: refresh };
  badges(parseInt(D.count, 10) || 0);
})();
